import React, { useState, useEffect } from "react";
import { Toaster, toast } from "react-hot-toast";
import { showToast } from "../../Helpers/showToast";
import { POST, SUPERGET, SUPERPOST } from '../../Services/AxiosService';
import { HiArrowNarrowRight } from "react-icons/hi";
import { useNavigate, useParams } from "react-router-dom";
import Logo from "../../Images/easytradelogo.png";
import { CustomStringify } from "../../Helpers/CustomStringify";
import { useDispatch, useSelector } from "react-redux";

import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import InputAdornment from '@mui/material/InputAdornment';
import Backdrop from "@mui/material/Backdrop";
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import CircularProgress from "@mui/material/CircularProgress";
import FormControl from '@mui/material/FormControl';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { fetchDataUser } from "../../Redux/UserDetail/UserDetailSlice";
import axios from "axios";
import { API_URL } from '../../env';

export default function Login() {
  const { cmpdetail, status, error } = useSelector((state) => state.CompanyDetail);
  const userData = useSelector((state) => state.UserDetail);

  const dispatch = useDispatch();
  const { token } = useParams();
  const navigate = useNavigate();
  const [UserName, setuserName] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const [Loader, setLoader] = useState(false);

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const togglePasswordVisibility = () => {
    setShowPassword((show) => !show);
  };

  const handleLogin = async () => {
    if (!UserName || !password) {
      showToast("Please fill in both Username and Password", "error");
      return;
    }
    dispatch(fetchDataUser({ key: cmpdetail?.key, UserName: UserName, password: password }))
  };


  const runCheckandUpdates = async (key) => {
    try {
      let response = await axios.post(`${API_URL}/checkandupdate/${key}`,
        { key: cmpdetail?.key, },
        { headers: { "Content-Type": "application/json", }, }
      );

      if (response?.data?.success) {
        toast.success(response?.data?.message)
        localStorage?.setItem("token", token);
        localStorage?.setItem("user", `${UserName}:${password}`);
        navigate("/CompanyDashboard");
      } else {
        if (token) {
          navigate(`/login/${token}`);

        }
      }
    } catch (error) {
      console.log(error);
    }
  };


  useEffect(() => {
    if (userData?.status == "loading") {
      setLoader(true);
    } else if (userData?.status == "succeeded") {
      runCheckandUpdates(cmpdetail?.key);
    } else if (userData?.status == "failed") {
      setLoader(false);
      showToast(userData?.result?.message, "error");
    }
  }, [userData?.status])



  useEffect(() => {
    var admin = document.getElementById("admin");
    var password = document.getElementById("pass");

    const keyEnter = (event) => {
      if (event.key === "Enter") {
        event.preventDefault();
        if (event.target.id == "pass") {
          handleLogin();
        } else if (event.target.id == "admin") {
          password.focus();
        } else {
          admin.focus();
        }
      }
    };

    document.addEventListener("keydown", keyEnter);

    return () => {
      document.removeEventListener("keydown", keyEnter);
    };
  });


  const login = createTheme({
    palette: {
      primary: {
        main: "#fff",
      },
    },
    typography: {
      fontFamily: "Poppins",
    },
    components: {
      MuiInputBase: {
        styleOverrides: {
          root: {
            color: "#fff",
            height: "50px",
            padding: "0 5px 0 5px",
          },
          input: {
            '&:-webkit-autofill': {
              padding: "12px",
            },
          },
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            marginTop: "-4px",
            padding: "0 5px 0 5px"
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            color: "#000",
            fontSize: "14.5px",
            fontWeight: 500,
            height: "45px",
            borderRadius: "50px"
          },
        },
      },
    },
  });

  return (
    <>
      <div className="row g-0">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="login-box-1 border-0 rounded-0 someClass-login p-5">
            <div className="row">
              <div className="col-12 m-auto p-5 mt-5">
                <img src={Logo} className="" style={{ width: "10%", position: "absolute", top: 50, left: 50 }} />
                <img src={`https://application.eterp.in/files/master/${cmpdetail?.logo}`} className="" style={{ width: "100%" }} />
                <div className="text-center run-business-text">
                  {cmpdetail?.company_name}
                </div>
                <Typography sx={{ color: "#fff", fontSize: "35px", textAlign: "center", mt: 1 }}>Vendor Login</Typography>
                {/* <div
                  className="text-center"
                  style={{
                    color: "#AAA",
                    fontSize: 12,
                    fontWeight: 400,
                    fontFamily: "Poppins",
                    fontStyle: "normal",
                    lineHeight: "normal",
                  }}
                >
                  integrated on the cloud!
                </div> */}
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="login-box-2 border-0 rounded-0 someClass py-0">
            <ThemeProvider theme={login}>
              <Box
                sx={{
                  maxWidth: '400px',
                  margin: 'auto',
                  padding: '20px',
                  // borderRadius: '8px',
                  // boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                }}
              >
                {/* <Typography sx={{ color: "#fff", fontSize: "35px", textAlign: "center", mt: 1 }}>Vendor Login</Typography> */}
                <Typography sx={{ color: "#fff", fontSize: "35px", textAlign: "center" }}>Welcome To</Typography>
                <Typography sx={{ color: "#fff", fontSize: "18px", textAlign: "center" }}>Vendor Login</Typography>
                <TextField
                  fullWidth
                  focused
                  id="admin"
                  label="Username"
                  name="username"
                  value={UserName}
                  onChange={(e) => setuserName(e.target.value)}
                  margin="normal"
                  InputProps={{
                    style: {
                      borderRadius: "50px",
                    }
                  }}
                  sx={{ mt: 4 }}
                />
                <FormControl fullWidth focused sx={{ mt: 2 }} variant="outlined">
                  <InputLabel htmlFor="pass">Password</InputLabel>
                  <OutlinedInput
                    id="pass"
                    type={showPassword ? 'text' : 'password'}
                    value={password}
                    onChange={handlePasswordChange}
                    sx={{ borderRadius: "50px" }}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label={
                            showPassword ? 'hide the password' : 'display the password'
                          }
                          onClick={togglePasswordVisibility}
                          edge="end"
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    }
                    label="Password"
                  />
                </FormControl>
                <Button fullWidth type="submit" variant="contained" color="primary" endIcon={<HiArrowNarrowRight />} onClick={handleLogin} sx={{ mt: 2 }}>
                  Login
                </Button>
                {/* <Box sx={{ mt: 2, textAlign: 'center', cursor: "pointer" }}>
                  <Typography variant="body1" onClick={() => navigate("/ForgotPassword")} sx={{ transition: "0.7s", '&:hover': { color: '#010101', textDecoration: "underline" } }}>
                    Forgot Password?
                  </Typography>
                </Box> */}
              </Box>
            </ThemeProvider>

            <Backdrop
              sx={{
                color: "#fff",
                zIndex: (theme) => theme.zIndex.drawer + 1,
              }}
              open={Loader}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
          </div>
        </div>
      </div>
      <Toaster position="top-center" reverseOrder={false} />
    </>
  );
}
